class SubscribePopup extends HTMLElement {
  constructor() {
    super();
    this.popup = this;
    this.popupSection = this.closest('.section-subscribe-popup');
    this.closeButton = this.querySelector('.subscribe-close-popup');
    this.form = this.querySelector('#subscribe-block-form');
    this.inputField = this.querySelector('.subscribe-block-form__field-wrapper .field__input');
    this.overlay = document.querySelector('.subscribe-block-overlay');
    this.maxShowTimes = parseInt(this.getAttribute('data-show-subscribe'), 10) || 0;
    this.closeCount = Number(sessionStorage.getItem('subsribePopupCloseCount')) || 0;
    this.formSubmitted = localStorage.getItem('subsribeFormSubmitted') === 'true';
    this.popupShown = false;

    // Focus management
    this.previouslyFocusedElement = null;

    this.scrolledMoreThanDistance = false;
    this.pageLoadedMoreThanTime = false;

    this.POPUP_DELAY = 16000;
    this.POPUP_DELAY_SCROLL = 10;

    this.init();
  }

  init() {
    if (!this.popupSection || this.closeCount >= this.maxShowTimes || this.formSubmitted) return;

    this.handleScroll();
    setTimeout(() => this.onPageLoadedTime(), this.POPUP_DELAY);

    this.closeButton?.addEventListener('click', () => this.hidePopup());
    this.closeButton?.addEventListener('keydown', (event) => {
      const isEnter = event.key === 'Enter';
      const isSpace = event.key === ' ' || event.key === 'Spacebar';
      const isEscape = event.key === 'Escape' || event.key === 'Esc';
      if (isEnter || isSpace || isEscape) {
        event.preventDefault();
        this.hidePopup(true);
      }
    });

    this.overlay?.addEventListener('click', () => this.hidePopup());

    document.addEventListener('keydown', (event) => {
      const isEscape = event.key === 'Escape' || event.key === 'Esc';
      if (!isEscape) return;
      if (this.popupSection?.classList.contains('popup-visible')) this.hidePopup(true);
    });

    if (this.form) {
      this.form.addEventListener('submit', () => {
        localStorage.setItem('subsribeFormSubmitted', 'true');
      });
    }
  }

  showPopup() {
    if (!this.popupShown) {
      this.previouslyFocusedElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;

      this.popupSection.classList.remove('popup-hidden');
      this.popupSection.classList.add('popup-visible');
      this.popupShown = true;

      setTimeout(() => {
        const initialFocus = this.inputField || this.closeButton || this.popupSection;
        if (typeof trapFocus === 'function') {
          trapFocus(this.popupSection, initialFocus);
        } else if (initialFocus) {
          initialFocus.focus();
        }
      }, 100);
    }
  }

  hidePopup(fromKeyboard = false) {
    if (!this.popupSection) return;
  
    this.popupSection.classList.remove('popup-visible');
    this.popupSection.classList.add('popup-hidden');
  
    this.closeCount++;
    sessionStorage.setItem('subsribePopupCloseCount', this.closeCount);
  
    const elementToFocus =
      fromKeyboard && this.previouslyFocusedElement && document.contains(this.previouslyFocusedElement)
        ? this.previouslyFocusedElement
        : null;
  
    if (typeof removeTrapFocus === 'function') {
      removeTrapFocus(elementToFocus || null);
    } else if (elementToFocus && typeof elementToFocus.focus === 'function') {
      setTimeout(() => {
        if (document.contains(elementToFocus)) {
          elementToFocus.focus();
        }
      }, 100);
    }
  
    this.previouslyFocusedElement = null;
  }

  checkScroll() {
    const scrolledPercentage = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;

    if (scrolledPercentage > this.POPUP_DELAY_SCROLL) {
      this.scrolledMoreThanDistance = true;
      window.removeEventListener('scroll', this.checkScroll);

      if (this.pageLoadedMoreThanTime) {
        this.showPopup();
      } else {
        setTimeout(() => this.showPopup(), this.POPUP_DELAY);
      }
    }
  }

  onPageLoadedTime() {
    this.pageLoadedMoreThanTime = true;
    if (this.scrolledMoreThanDistance) this.showPopup();
  }

  handleScroll() {
    const initialScrolledPercentage = (window.scrollY + window.innerHeight) / document.documentElement.scrollHeight * 100;

    if (initialScrolledPercentage > this.POPUP_DELAY_SCROLL) {
      this.scrolledMoreThanDistance = true;
      if (!this.pageLoadedMoreThanTime) {
        setTimeout(() => this.showPopup(), this.POPUP_DELAY);
      }
    } else {
      window.addEventListener('scroll', this.checkScroll.bind(this));
    }
  }
}

customElements.define('subscribe-popup', SubscribePopup);